import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    pendo: any
  }
}

const usePendoScript = (pendoKey: string, isValidKey: boolean) => {
  useEffect(() => {
    if (!isValidKey) {
      return
    }

    const scriptTag = document.createElement('script')
    scriptTag.innerHTML = `
      ;(function (apiKey) {
        ;(function (p, e, n, d, o) {
          var v, w, x, y, z;
          o = p[d] = p[d] || {};
          o._q = o._q || [];
          v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
          for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
              o[m] =
                o[m] ||
                function () {
                  o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                };
            })(v[w]);
          y = e.createElement(n);
          y.async = !0;
          y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
          z = e.getElementsByTagName(n)[0];
          z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
      })("${pendoKey}");
    `

    document.head.appendChild(scriptTag)

    return () => {
      scriptTag.remove()
    }
  }, [isValidKey, pendoKey])
}
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const usePendoInitialization = (user: any) => {
  useEffect(() => {
    const pendo = window.pendo
    const userName = user?.profile?.name
    const customerName = user?.profile?.customer_name
    const userEmail = user?.profile?.email
    const userId = user?.profile?.sub

    if (pendo && userId) {
      console.log('Initialize pendo')
      pendo.initialize({
        account: {
          customer: customerName,
          email: userEmail,
          id: userId,
          name: userName
        },
        visitor: {
          id: userName
        }
      })
    }
  }, [user])
}

export const TrackingComponent = () => {
  const auth = useAuth()
  const user = auth.user

  const pendoKey = import.meta.env.NX_PENDO_ID as string
  const isValidKey = !!(pendoKey && !pendoKey.includes('50783fe6-fd32-4e2f-4b07-37c15f1e5981'))

  usePendoScript(pendoKey, isValidKey)
  usePendoInitialization(user)

  return <></>
}
